// Transform technical database/API errors into user-friendly messages

export function getUserFriendlyError(error) {
  const message = error?.message || String(error);
  
  // Database constraint violations
  if (message.includes('violates not-null constraint')) {
    return 'Something went wrong. Please try again or contact support if the issue persists.';
  }
  
  if (message.includes('violates unique constraint') || message.includes('duplicate key')) {
    if (message.includes('username')) {
      return 'This username is already taken. Please choose another.';
    }
    if (message.includes('email')) {
      return 'This email is already registered.';
    }
    return 'This item already exists.';
  }
  
  if (message.includes('violates foreign key constraint')) {
    return 'Unable to complete this action. The related item may have been deleted.';
  }
  
  if (message.includes('violates check constraint')) {
    return 'Invalid data provided. Please check your input and try again.';
  }
  
  // Auth errors
  if (message.includes('Invalid login credentials')) {
    return 'Incorrect email or password. Please try again.';
  }
  
  if (message.includes('Email not confirmed')) {
    return 'Please confirm your email address before continuing.';
  }
  
  if (message.includes('User already registered')) {
    return 'An account with this email already exists.';
  }
  
  // Network errors
  if (message.includes('Failed to fetch') || message.includes('Network request failed')) {
    return 'Connection error. Please check your internet and try again.';
  }
  
  if (message.includes('timeout')) {
    return 'Request timed out. Please try again.';
  }
  
  // Permission errors
  if (message.includes('permission denied') || message.includes('not authorized')) {
    return 'You don\'t have permission to do that.';
  }
  
  // File upload errors
  if (message.includes('file too large') || message.includes('exceeds maximum')) {
    return 'File is too large. Please choose a smaller file.';
  }
  
  // Default: if it's a short, clear message, keep it. Otherwise, generic message
  if (message.length < 100 && !message.includes('SQLSTATE') && !message.includes('relation')) {
    return message;
  }
  
  return 'Something went wrong. Please try again.';
}
